/**
 * User Utils
 */

export default {
  /**
   * Get Environment Type by host
   */
  getEnvironmentType:function() {
    return location.host === 'matcha-jp.com' ? 'prod' : 'dev';
  },

  /**
   * Validate Email Regex
   */
  validateEmailRegex: function (email) {
    if (!email) return false
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  },

  /**
   * Convert To Language Name From Language Id
   */
  convertToLanguageName: function (languageId) {
    let langName = ''

    switch (parseInt(languageId)) {
      case 1:
        langName = 'jp'
        break
      case 2:
        langName = 'en'
        break
      case 3:
        langName = 'tw'
        break
      case 4:
        langName = 'th'
        break
      case 5:
        langName = 'ko'
        break
      case 6:
        langName = 'cn'
        break
      case 7:
        langName = 'id'
        break
      case 8:
        langName = 'vn'
        break
      case 9:
        langName = 'easy'
        break
    }
    return langName
  },


  /**
   * Parse JWT Token to Real Plain Token
   * @param {*} token 
   */
  parseJwt: function (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    var plain_token = JSON.parse(window.atob(base64));
    // console.log(plain_token)
    return plain_token;
  },
  
  /**
   * return Language Matrix
   */
  getLanguages: () => {
    return {
      1  : '日本語',
      2  : 'English',
      3  : '中文繁體',
      4  : 'ภาษาไทย',
      5  : '한국어',
      6  : '中文简体',
      7  : 'Indonesian',
      8  : 'Việt Nam',
      9  : 'やさしい日本語',
      10 : 'Español'
    }
  },


  getDate: (d) => {
    let day,
        month,
        year,
        dmy = d.match("[0-9]{2}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{4}"),
        ymd = d.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}")

    if(dmy !== null) {
        var dateSplitted = dmy[0].split(dmy[1])
        day = dateSplitted[0]
        month = dateSplitted[1]
        year = dateSplitted[2]
    }else if(ymd !== null) {
        var dateSplitted = ymd[0].split(ymd[1])
        day = dateSplitted[2]
        month = dateSplitted[1]
        year = dateSplitted[0]
    }

    // Swapping DD && MM 
    if(month>12) {
        aux = day
        day = month
        month = aux
    }

    return {year, month, day}
  }

}



// WEBPACK FOOTER //
// ./src/utils/UserUtils.js